import { LOINCAnswerCodes } from "@/fhir/enums/loinc";
import { Systems } from "@/fhir/enums/systems";

export const YES_DISPLAY = "Yes";
export const NO_DISPLAY = "No";

export type YesNoDisplay = typeof YES_DISPLAY | typeof NO_DISPLAY;

export type YesNoLoincCoding = {
  system: typeof Systems.LOINC;
  code: LOINCAnswerCodes.Yes | LOINCAnswerCodes.No;
  display: YesNoDisplay;
};
